(() => {
  const FUNCTION_URL = "https://uquszxjagskyuxmstmoa.functions.supabase.co/valentine-message";
  const SHARED_SECRET = ""; // Optional: set if SHOPIFY_SHARED_SECRET is enabled
  const TARGET_TEXTAREA_SELECTORS = [
    "textarea[name=\"properties[Message on back of label (max 40 words)]\"]",
    "textarea[name*=\"properties[Message on back of label\"]",
    "textarea[name*=\"Message on back of label\"]",
    "textarea.custom-option__text-input",
  ];

  function init() {
    const root = document.getElementById("valentine-message-assistant");
    if (!root) return;

    const textArea = root.querySelector("#vma-text");
    const nameInput = root.querySelector("#vma-name");
    const inputCount = root.querySelector("#vma-input-count");
    const statusEl = root.querySelector("#vma-status");
    const primaryBtn = root.querySelector("#vma-primary");
    const resetBtn = root.querySelector("#vma-reset");
    const useBtn = root.querySelector("#vma-use");
    const prevBtn = root.querySelector("#vma-prev");
    const nextBtn = root.querySelector("#vma-next");
    const modal = document.getElementById("vma-modal");
    const closeButtons = Array.from(document.querySelectorAll("[data-vma-close]"));

    const styleInputs = Array.from(root.querySelectorAll("input[name='vma-style']"));
    const occasionInputs = Array.from(root.querySelectorAll("input[name='vma-occasion']"));
    const toneInputs = Array.from(root.querySelectorAll("input[name='vma-tone']"));
    const emojiToggle = root.querySelector("#vma-emoji");

    const MAX_WORDS = 40;

    let lastPayload = null;
    let responseCache = [];
    let responseIndex = 0;

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function wordCount(text) {
      const trimmed = text.trim();
      if (!trimmed) return 0;
      return trimmed.split(/\s+/).length;
    }

    function trimToWordLimit(text, limit) {
      const trimmed = text.trim();
      if (!trimmed) return "";
      const words = trimmed.split(/\s+/);
      if (words.length <= limit) return trimmed;
      return words.slice(0, limit).join(" ");
    }

    function setStatus(message, isError = false) {
      statusEl.textContent = message || "";
      statusEl.style.color = isError ? "#8b1e1e" : "#2f2a24";
    }

    function setLoading(isLoading) {
      [primaryBtn, useBtn].forEach((btn) => {
        btn.classList.toggle("vma__disabled", isLoading);
        btn.disabled = isLoading;
      });
      primaryBtn.classList.toggle("vma__loading", isLoading);
      primaryBtn.textContent = isLoading ? "Creating..." : "Create message";
    }

    function updateUseVisibility() {
      const hasText = textArea.value.trim().length > 0;
      useBtn.style.display = hasText ? "" : "none";
    }

    function updateNav() {
      if (!prevBtn || !nextBtn) return;
      const hasMultiple = responseCache.length > 1;
      prevBtn.style.display = hasMultiple ? "" : "none";
      nextBtn.style.display = hasMultiple ? "" : "none";
      prevBtn.disabled = responseIndex <= 0;
      nextBtn.disabled = responseIndex >= responseCache.length - 1;
    }

    function setCurrentResponse(index) {
      if (!responseCache.length) return;
      const clamped = Math.max(0, Math.min(index, responseCache.length - 1));
      responseIndex = clamped;
      textArea.value = responseCache[responseIndex] || "";
      updateInputCount();
      updateUseVisibility();
      updateNav();
    }

    function appendResponses(responses) {
      const cleaned = responses.filter((item) => typeof item === "string" && item.trim());
      if (!cleaned.length) return;
      const startIndex = responseCache.length;
      responseCache = responseCache.concat(cleaned);
      setCurrentResponse(startIndex);
    }

    function updateInputCount() {
      const count = wordCount(textArea.value);
      inputCount.textContent = `${count} / ${MAX_WORDS} words`;
      if (count > MAX_WORDS) {
        textArea.classList.add("vma__input--error");
        setStatus("Input exceeds 40 words.", true);
        primaryBtn.disabled = true;
        return false;
      }
      textArea.classList.remove("vma__input--error");
      return true;
    }

    function getSelectedValue(inputs, fallback) {
      const active = inputs.find((input) => input.checked);
      return (active && active.value) || fallback;
    }

    function buildPayload() {
      const senderName = (nameInput?.value || "").trim();
      return {
        mode: "generate",
        senderName: senderName || undefined,
        style: getSelectedValue(styleInputs, "message"),
        occasion: getSelectedValue(occasionInputs, "valentine"),
        tone: getSelectedValue(toneInputs, "sweet"),
        length: "medium",
        emoji: emojiToggle.checked ? "few" : "none",
        keepFacts: true,
        language: "en",
      };
    }

    function setOutput(text) {
      const safeText = trimToWordLimit(text || "", MAX_WORDS);
      textArea.value = safeText;
      updateInputCount();
      updateUseVisibility();
    }

    function getTargetTextarea() {
      for (const selector of TARGET_TEXTAREA_SELECTORS) {
        const target = document.querySelector(selector);
        if (target) return target;
      }
      return null;
    }

    function setTargetMessage(value) {
      const target = getTargetTextarea();
      if (!target) return false;
      target.value = value;
      target.dispatchEvent(new Event("input", { bubbles: true }));
      return true;
    }

    function openModal() {
      if (!modal) return;
      const target = getTargetTextarea();
      if (target) {
        textArea.value = target.value || "";
        updateInputCount();
      }
      updateUseVisibility();
      modal.classList.remove("is-hidden");
      modal.removeAttribute("hidden");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("vma-modal-open");
      document.body.classList.add("vma-modal-open");
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.add("is-hidden");
      modal.setAttribute("hidden", "");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("vma-modal-open");
      document.body.classList.remove("vma-modal-open");
    }

    async function callApi(payload) {
      if (!updateInputCount()) return;
      setLoading(true);
      setStatus("Working...");

      try {
        const headers = { "Content-Type": "application/json" };
        if (SHARED_SECRET) headers["x-shopify-shared-secret"] = SHARED_SECRET;

        const resp = await fetch(FUNCTION_URL, {
          method: "POST",
          headers,
          body: JSON.stringify(payload),
        });

        const data = await resp.json();
        if (!data.ok) {
          setStatus(data.message || "Something went wrong.", true);
          return;
        }

        const results = Array.isArray(data.resultTexts)
          ? data.resultTexts
          : [data.resultText].filter(Boolean);
        appendResponses(results);
        setStatus("Ready.");
        lastPayload = payload;
      } catch (_err) {
        setStatus("Network error. Try again.", true);
      } finally {
        setLoading(false);
      }
    }

    textArea.addEventListener("input", () => {
      updateInputCount();
      updateUseVisibility();
    });

    function clearCachedResponses() {
      responseCache = [];
      responseIndex = 0;
      updateNav();
      updateUseVisibility();
    }

    styleInputs.forEach((input) => {
      input.addEventListener("change", () => {
        setStatus("");
        clearCachedResponses();
      });
    });

    occasionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        setStatus("");
        clearCachedResponses();
      });
    });

    toneInputs.forEach((input) => {
      input.addEventListener("change", () => {
        setStatus("");
        clearCachedResponses();
      });
    });

    primaryBtn.addEventListener("click", () => {
      const payload = buildPayload();
      callApi(payload);
    });

    resetBtn.addEventListener("click", () => {
      textArea.value = "";
      if (nameInput) nameInput.value = "";
      inputCount.textContent = "0 / 40 words";
      styleInputs[0] && (styleInputs[0].checked = true);
      occasionInputs[0] && (occasionInputs[0].checked = true);
      toneInputs[0] && (toneInputs[0].checked = true);
      emojiToggle.checked = true;
      lastPayload = null;
      clearCachedResponses();
      setStatus("");
    });

    useBtn.addEventListener("click", () => {
      const message = textArea.value.trim();
      if (!message) {
        setStatus("Generate a message first.", true);
        return;
      }
    if (!setTargetMessage(message)) {
      setStatus("Message field not found.", true);
      return;
    }
    setStatus("");
    closeModal();
  });

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", closeModal);
    });

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => setCurrentResponse(responseIndex - 1));
      nextBtn.addEventListener("click", () => setCurrentResponse(responseIndex + 1));
    }

    function ensureLaunchButton() {
      const targetInput = getTargetTextarea();
      if (!targetInput) return false;
      if (targetInput.dataset.vmaLaunchAttached === "true") return true;
      const launchBtn = document.createElement("button");
      launchBtn.type = "button";
      launchBtn.className = "btn btn--secondary vma-launch";
      launchBtn.textContent = "Open Message Assistant";
      targetInput.insertAdjacentElement("afterend", launchBtn);
      targetInput.dataset.vmaLaunchAttached = "true";
      launchBtn.addEventListener("click", openModal);
      return true;
    }

    if (!ensureLaunchButton()) {
      const observer = new MutationObserver(() => {
        if (ensureLaunchButton()) {
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    updateInputCount();
    updateUseVisibility();
    updateNav();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
